/** The out-of-the-box "Other" source, which the Source filter does not offer (Shaun, 2026-10-23). */
export const SOURCE_OTHER_GUID = 'ef20c545-acd7-4989-8e9f-1fb13422e652';

/** The Source filter's choices: every source the tenant has but Other, in name order. No "No Source" choice. */
export const formatSource = (list: { Id: number; Value: string; Guid?: string }[] | null | undefined) =>
  [...(list ?? [])]
    .filter(source => source.Guid?.toLowerCase() !== SOURCE_OTHER_GUID)
    .sort((a, b) => a.Value.localeCompare(b.Value))
    .map(source => ({ key: source.Id, title: source.Value, selected: false }));
